import { getPageImage } from "@/lib/page-imagery";
const contactHero = getPageImage("/contact");
import { EditorialHero } from "./EditorialHero";
import { EnquiryComposer } from "./EnquiryComposer";
import { whatsappUrl } from "@/lib/content";
import { useLanguage } from "@/lib/language";
export function ContactContent() {
  const { t } = useLanguage();
  return (
    <>
      <EditorialHero image={contactHero.src} alt={t(contactHero.alt)}>
        <p className="ic-eyebrow">{t({ en: "Talk to IraqCert", ar: "تواصل مع عراق سيرت" })}</p>
        <h1 className="ic-title">
          {t({ en: "Tell us what you need to prepare.", ar: "أخبرنا بما تحتاج إلى تجهيزه." })}
        </h1>
        <p className="ic-intro">
          {t({
            en: "ISO preparation, management systems or supplier registration. Start with the requirement; we’ll review the support and scope with you.",
            ar: "التحضير للأيزو أو أنظمة الإدارة أو تسجيل الموردين. ابدأ بالمتطلب، لنراجع معك نطاق الدعم والعمل.",
          })}
        </p>
        <a
          href={`${whatsappUrl}?text=${encodeURIComponent(
            t({
              en: "Hello IraqCert, I would like to discuss my requirement.\nCompany activity:\nLocation:\nBuyer requirement or standard:\nPage: /contact",
              ar: "مرحباً عراق سيرت، أود مناقشة متطلب شركتي.\nنشاط الشركة:\nالموقع:\nمتطلب المشتري أو المواصفة:\nالصفحة: /ar/contact",
            }),
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="ic-button mt-7"
        >
          {t({ en: "Start your enquiry in WhatsApp", ar: "ابدأ استفسارك عبر واتساب" })}
        </a>
      </EditorialHero>
      <section className="ic-section ic-contact-grid">
        <EnquiryComposer />
        <div className="ic-contact-details">
          <h2>{t({ en: "Choose how to contact us", ar: "اختر وسيلة التواصل" })}</h2>
          <p>
            {t({
              en: "You can also call, email or start a blank WhatsApp conversation.",
              ar: "يمكنك أيضاً الاتصال أو إرسال بريد إلكتروني أو بدء محادثة واتساب مباشرة.",
            })}
          </p>
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="ic-text-link">
            {t({ en: "Open WhatsApp", ar: "افتح واتساب" })}
          </a>
          <a href="tel:+9647874946122" className="ic-text-link">
            <span>{t({ en: "Call", ar: "اتصل" })} </span>
            <bdi dir="ltr">+964 787 494 6122</bdi>
          </a>
          <a href="mailto:info@iraqcert.com" className="ic-text-link" dir="ltr">
            info@iraqcert.com
          </a>
          <div className="mt-9">
            <h3>
              {t({
                en: "Based in Erbil. Supporting teams across Iraq.",
                ar: "مقرّنا في أربيل. ندعم الفرق في أنحاء العراق.",
              })}
            </h3>
            <p>
              {t({
                en: "We work by phone and message, with client-site visits agreed when needed. Contact us first; our premises are not open for walk-in visits.",
                ar: "نتواصل هاتفياً وبالرسائل، ونرتّب زيارة موقع العميل عند الحاجة. تواصل معنا أولاً؛ مقرّنا غير مفتوح للزيارات المباشرة.",
              })}
            </p>
          </div>
          <div className="mt-9">
            <h3>{t({ en: "What happens next", ar: "ماذا بعد التواصل؟" })}</h3>
            <p>
              {t({
                en: "We review the requirement, clarify your activities and sites, and discuss the work to be included. An audit, certificate or buyer approval is a separate step—not an automatic result of contacting us.",
                ar: "نراجع المتطلب ونوضح أنشطتك ومواقعك ونناقش الأعمال التي يشملها الدعم. التدقيق والشهادة وقبول المشتري مراحل مستقلة، ولا تنتج تلقائياً عن التواصل معنا.",
              })}
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
